export default "__VITE_ASSET__0wThgpZ4__"